<template>
  <!-- Imagen -->
  <div
    v-if="bloque.id_tipo_de_bloque === 'galeria_imagenes'"
    class="item-imagen link-item-list-preview-no-bgnd item-titulo-de-seccion"
    @click="registraEvento(bloque, 'click_bloque')"
  >
    <!-- TITULO -->
    <f7-row class="text-align-center item-formulario-header">
      <f7-col width="100">
        <div class="item-title">{{ bloque.nombre_bloque }}</div>
      </f7-col>
    </f7-row>
    <!-- GALERIA ORDENADA -->
    <f7-row class="justify-content-space-around" v-if="bloque.tipo_galeria_imagenes === 'ordenada'">
      <f7-col
        v-for="imagen in bloque.galeria_imagenes"
        :key="imagen"
        :width="columnGallery"
      >
        <span class="grid-image-container" @click="openLightbox(imagen)">
          <img class="grid-image" :src="imagen" alt="" /> </span
      ></f7-col>
    </f7-row>

    <!-- GALERIA MASONRY -->
    <div class="masonry"  v-if="bloque.tipo_galeria_imagenes === 'masonry'">
      <div v-for="imagen in bloque.galeria_imagenes"
        :key="imagen" class="grid" @click="openLightbox(imagen)">
        <img :src="imagen" />
        <div class="grid__body">
          <div class="relative">
            <a class="grid__link" target="_blank" href="/"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- LIGHTBOX -->
    <f7-sheet
      :opened="lightboxOpened"
      backdrop
      @sheet:closed="closeLightbox"
      style="
        height: 100vh;
        overflow: hidden;
        margin: 0;
        width: 100%;
        border-radius: 0px;
        position: fixed;
        background: rgba(0, 0, 0, 0.9);
      "
    >
      <f7-page-content style="display: flex; align-items: center; justify-content: center; height: 100%;">
        <div style="position: relative; width: 100%; height: 100%;">
          <img :src="currentImage" style="width: 100%; height: 100%; object-fit: cover;" />
          <f7-button
            @click="closeLightbox"
            style="
              position: absolute;
              bottom: 20px;
              right: 20px;
              background: rgba(255, 255, 255, 0.8);
              color: #000;
              border-radius: 50%;
              width: 40px;
              height: 40px;
              padding: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <i class="fas fa-times"></i>
          </f7-button>
        </div>
      </f7-page-content>
    </f7-sheet>

  </div>
</template>

<script>
import crudBloques from "../../../js/crud-bloques";

export default {
  props: {
    bloque: Object,
  },
  data() {
    return {
      columnGallery: 50,
      lightboxOpened: false,
      currentImage: "",
    }
  },
  mounted() {
    const self = this;
    if (window.innerWidth >= 568) {
      self.columnGallery = 33
    } else {
      self.columnGallery = 50
    }
  },
  methods: {
    registraEvento(bloque, evento, redirect = false, redirectUrl = "") {
      const self = this;
      crudBloques.registraEvento(self, bloque, evento, redirect, redirectUrl);
    },
    openLightbox(imagen) {
      this.currentImage = imagen;
      this.lightboxOpened = true;
    },
    closeLightbox() {
      this.lightboxOpened = false;
      this.currentImage = "";
    },
  },
};
</script>
